<div class="canvas-container" #canvasContainer (dragover)="onDragOver($event)" (drop)="onDrop($event)">
    <div class="tool-indicator" [attr.data-tool]="currentTool()">
        <span class="tool-icon">{{ getToolIcon() }}</span>
    </div>
    <div class="canvas-stage" [class.align-top]="isCanvasTall()">
        @if (isSplitView()) {
            <div class="canvas-pair">
                <div
                    class="canvas-wrapper"
                    [style.width.px]="canvasWrapperWidth()"
                    [style.height.px]="canvasWrapperHeight()">
                    <div class="svg-overlay" [style.width.px]="canvasStyleWidth()" [style.height.px]="canvasStyleHeight()">
                        @for (svgObj of svgOverlayObjects(); track svgObj.id) {
                            @if (svgOverlaySrc(svgObj)) {
                                <img
                                    class="svg-overlay-item"
                                    [src]="svgOverlaySrc(svgObj)"
                                    [ngStyle]="svgOverlayStyle(svgObj)"
                                    alt="SVG overlay" />
                            }
                        }
                    </div>
                    <canvas
                        #canvas
                        class="canvas"
                        [style.width.px]="canvasStyleWidth()"
                        [style.height.px]="canvasStyleHeight()"
                        (mousedown)="onMouseDown($event)"
                        (dblclick)="onDoubleClick($event)"
                        (mousemove)="onMouseMove($event)"
                        (mouseup)="onMouseUp($event)"
                        (wheel)="onWheel($event)">
                    </canvas>
                </div>
                <div
                    class="canvas-wrapper preview"
                    [style.width.px]="canvasWrapperWidth()"
                    [style.height.px]="canvasWrapperHeight()">
                    <canvas
                        #canvasPreview
                        class="canvas preview"
                        [style.width.px]="canvasStyleWidth()"
                        [style.height.px]="canvasStyleHeight()">
                    </canvas>
                </div>
            </div>
        } @else {
            <div
                class="canvas-wrapper"
                [style.width.px]="canvasWrapperWidth()"
                [style.height.px]="canvasWrapperHeight()">
                <div class="svg-overlay" [style.width.px]="canvasStyleWidth()" [style.height.px]="canvasStyleHeight()">
                    @for (svgObj of svgOverlayObjects(); track svgObj.id) {
                        @if (svgOverlaySrc(svgObj)) {
                            <img
                                class="svg-overlay-item"
                                [src]="svgOverlaySrc(svgObj)"
                                [ngStyle]="svgOverlayStyle(svgObj)"
                                alt="SVG overlay" />
                        }
                    }
                </div>
                <canvas
                    #canvas
                    class="canvas"
                    [style.width.px]="canvasStyleWidth()"
                    [style.height.px]="canvasStyleHeight()"
                    (mousedown)="onMouseDown($event)"
                    (dblclick)="onDoubleClick($event)"
                    (mousemove)="onMouseMove($event)"
                    (mouseup)="onMouseUp($event)"
                    (wheel)="onWheel($event)">
                </canvas>
            </div>
        }
    </div>
</div>
